$(function () {
    navPriceTable = {
        endpoint: '/Main/YieldMonitorNavPriceBlock/GetYieldMonitorNavPriceBlockData',
        tableData: {},
        tableHeaderArray: [],
        tableHeaderTitles: [],
        tableClassesArray: [],
        retrieved: false,
        wrapperDiv: $('#veNavPriceBlockTable'),
        navDataGroups: [],
        priceDataGroups: [],
        tableType: '',
        blockId: $('#veNavPriceBlockTable').attr("data-blockid"),
        toggleEventListenersAdded: false,
        toggleNavPriceEventListner: false,
        isExcelDownloading: false,

        init: () => {
            commonFundUtils.spinner.show("NavPriceDesktopTable");
            navPriceTable.manageDataArrays()
            commonFundUtils.spinner.hide("NavPriceDesktopTable");
        },
        manageDataArrays: async () => {
            navPriceTable.tableData = await commonFundUtils.getData(navPriceTable.blockId, navPriceTable.endpoint)
            //create seperate object array for the nav values
            $.each(navPriceTable.tableData.Groups, function () {
                let obj = Object.create({});
                obj.Strategy = this.Strategy
                obj.NavMonthItems = this.NavMonthItems
                obj.NavQuarterItems = this.NavQuarterItems
                navPriceTable.navDataGroups.push(obj)
            })
            //create a seperate object array for price values
            $.each(navPriceTable.tableData.Groups, function () {
                let obj = Object.create({});
                obj.Strategy = this.Strategy
                obj.PriceMonthItems = this.PriceMonthItems
                obj.PriceQuarterItems = this.PriceQuarterItems
                navPriceTable.priceDataGroups.push(obj)
            })
            navPriceTable.drawTable()
            navPriceTable.drawMobileTable()
            //console.log(navPriceTable.navDataGroups, navPriceTable.priceDataGroups);
        },
        //draw the table
        drawTable: () => {
            navPriceTable.tableType = $(".toggle-button-wrapper").attr("data-toggle");
            commonFundUtils.drawDesktopTable(
                "veNavPriceBlockTable",
                "NavPriceDesktopTable",
                navPriceTable.tableData,
                navPriceTable.drawHeader,
                navPriceTable.tableData,
            )
            navPriceTable.drawBlock(navPriceTable.tableHeaderArray, navPriceTable.tableClassesArray, navPriceTable.isExcelDownloading)
            navPriceTable.enableHeaderClicks()
            commonFundUtils.initiatePopover()
        },

        //used to draw the table header
        drawHeader: (dataSet) => {
            var tableheader;
            navPriceTable.tableHeaderArray = [];
            navPriceTable.tableClassesArray = [];
            navPriceTable.tableHeaderTitles = [];
            tableheader = '<thead>';
            tableheader += '<tr><th colspan="2"></th>'
                + '<th colspan = "2" style="border-bottom: 1px solid;"> Month-End ' + dataSet.MonthEndDate + '</th >'
                + '<th colspan = "3" style="border-bottom: 1px solid;"> Quarter-End ' + dataSet.QuarterEndDate + '</th>'
                + '<th colspan = "2"></th></tr>';
            tableheader += '<tr>'
            $.each(dataSet.MonthEndColumns, function () {
                tableheader += '<th class="table-header-item ' + this.CellClass + ' ' + commonFundUtils.getUnderlinedClass("veNavPriceBlockTable", this.ColumnName) + '" id="' + this.ColumnName + '"><span class="table-thead d-inline-flex">' + columnHeaderNameKVP[this.Name] + commonFundUtils.sortIconMarkup + '</span></th>';
                navPriceTable.tableHeaderArray.push(this.ColumnName);
                navPriceTable.tableClassesArray.push(this.CellClass);
                navPriceTable.tableHeaderTitles.push(columnHeaderNameKVP[this.Name])
            })
            $.each(dataSet.QuarterEndColumns, function () {
                tableheader += '<th class="table-header-item ' + this.CellClass + ' ' + commonFundUtils.getUnderlinedClass("veNavPriceBlockTable", this.ColumnName) + '" id="' + this.ColumnName + '"><span class="table-thead d-inline-flex">' + columnHeaderNameKVP[this.Name] + commonFundUtils.sortIconMarkup + '</span></th>';
                navPriceTable.tableHeaderArray.push(this.ColumnName);
                navPriceTable.tableClassesArray.push(this.CellClass);
                navPriceTable.tableHeaderTitles.push(columnHeaderNameKVP[this.Name])
            })
            tableheader += '</tr>'
            tableheader += '</thead>';
            return tableheader;
        },
        drawBlock: (headerArray, classArray, isExcel) => {
            let monthArray, quarterArray;
            let dataSet = [];
            dataSet = (navPriceTable.tableType == "NAV") ? navPriceTable.navDataGroups : navPriceTable.priceDataGroups;
            //console.log(dataSet)
            //$('#veNavPriceBlockTable table tbody').remove();
            var tableBlock = '<tbody>';
            $.each(dataSet, function () {
                if (navPriceTable.tableType == "NAV") {
                    monthArray = this.NavMonthItems
                    quarterArray = this.NavQuarterItems
                } else {
                    monthArray = this.PriceMonthItems
                    quarterArray = this.PriceQuarterItems
                }
                //const { NavMonthItems, NavQuarterItems } = this.dataSet
                //console.log("inside draw block",this.Strategy)
                tableBlock += '<tr class="table-title grouping"><td colspan="'+headerArray.length+'" class="text-left bold pt-3"><h5>' + this.Strategy + '</h5></td></tr>';
                $.each(monthArray, function (index) {
                    monthObj = this;
                    var linkVal = ("FormattedLink" in monthObj) && monthObj.FormattedLink !== null ? monthObj.FormattedLink : "#"
                    quarterObj = quarterArray[index];
                    tableBlock += '<tr>'
                    tableBlock += '<td class="' + classArray[0] + '"><a href="' + linkVal + '">' + monthObj[headerArray[0]] + '</a></td>'
                    if (monthObj.CardData && monthObj.CardData.MorningStarRating != null && !isExcel) {
                        tableBlock += '<td class="' + classArray[1] + '"><a class="fund-explorer-table-tooltip-item" href="' + linkVal + '">' + monthObj[headerArray[1]] + `${commonFundUtils.moreInfoIconMarkup}</a>${commonFundUtils.drawPopoverCard(monthObj.CardData)}</td>`
                    } else {
                        tableBlock += '<td class="' + classArray[1] + '"><a href="' + linkVal + '">' + monthObj[headerArray[1]] + '</a></td>'
                    }
                    
                    for (let i = 2; i < 4; i++) {
                        tableBlock += '<td class="' + classArray[i] + '">' + monthObj[headerArray[i]].toFixed(2) + '</td>'
                    }
                    for (let j = 4; j < (headerArray.length - 1); j++) {
                        tableBlock += '<td class="' + classArray[j] + '">' + quarterObj[headerArray[j]].toFixed(2) + '</td>'
                    } 

                    tableBlock += '<td class="' + classArray[headerArray.length - 1] + '">' + commonFundUtils.dateFormatter(quarterObj[headerArray[headerArray.length - 1]]) + '</td>';
                })
            })
            tableBlock+='</tbody>'
            if (isExcel) {
                navPriceTable.isExcelDownloading = false
                return tableBlock
            } else {
                $('#veNavPriceBlockTable table').append(tableBlock);
            }
        },
        sortArray : (dataSet) => {
            //console.log("dataset in page", dataSet);
            //debugger;
            var newDataSet =
                $.map(dataSet, function (item) {
                    //console.log(item.PriceMonthItems, navPriceTable.tableType)
                    if (navPriceTable.tableType == "NAV") {
                        item.NavMonthItems = commonFundUtils.sortData(item.NavMonthItems, navPriceTable.wrapperDiv);
                        item.NavQuarterItems = commonFundUtils.sortData(item.NavQuarterItems, navPriceTable.wrapperDiv);
                    }
                    if (navPriceTable.tableType == "Price"){
                        item.PriceMonthItems = commonFundUtils.sortData(item.PriceMonthItems, navPriceTable.wrapperDiv);
                        item.PriceQuarterItems = commonFundUtils.sortData(item.PriceQuarterItems, navPriceTable.wrapperDiv);
                    }
                    //console.log("created object", item)
                    return item;
                })
            //console.log(newDataSet)
            return newDataSet;
        },
        enableHeaderClicks: () => {
            $('#veNavPriceBlockTable thead .table-header-item').on("click", function () {
                commonFundUtils.changeDivAttributes(this, navPriceTable.wrapperDiv)
                if (navPriceTable.tableType == "NAV") {
                    navPriceTable.tableData.navDataGroups = navPriceTable.sortArray(navPriceTable.navDataGroups)
                }
                if (navPriceTable.tableType == "Price") {
                    navPriceTable.tableData.priceDataGroups = navPriceTable.sortArray(navPriceTable.priceDataGroups)
                }
                navPriceTable.drawTable()
            })
            if (navPriceTable.toggleNavPriceEventListner) return
            $(".toggle-button-wrapper").on("click", function () {
                ($(this).attr("data-toggle") == "NAV") ? $(this).attr("data-toggle", "Price") : $(this).attr("data-toggle", "NAV")
                $('.toggle-button-wrapper span').toggleClass("active")
                navPriceTable.drawTable()
                navPriceTable.drawMobileTable()
            })
            navPriceTable.toggleNavPriceEventListner = true

            //to run the excel button click event listner only once
            if (navPriceTable.toggleEventListenersAdded) return
            //activating the "download excel" button click only once
            commonFundUtils.generateExcelTable("veNavPriceBlockTable", navPriceTable.drawExcelTable)
            navPriceTable.toggleEventListenersAdded = true
        },
        drawMobileTable: () => {
            navPriceTable.tableType = $(".toggle-button-wrapper").attr("data-toggle");
            if ($('#NavPriceMobileTable').length != 0) {
                $('#NavPriceMobileTable').remove();
            }
            dataSet = (navPriceTable.tableType == "NAV") ? navPriceTable.navDataGroups : navPriceTable.priceDataGroups;
            var mobileTable = '<div id="NavPriceMobileTable">';
            mobileTable += '<div class="d-lg-none">'
                + '<div class="fund-listing-table table-mobile" id="NavPriceDataTable">'
            $.each(dataSet, function () {
                mobileTable += '<h3 class="my-3">' + this.Strategy + '</h3>';
                mobileTable += navPriceTable.drawMobileCardArray(this, 2, navPriceTable.tableHeaderArray)
            })
            if ($('#veNavPriceBlockTable .table-mobile .table-footer').length == 0 && navPriceTable.tableData.FooterText !== null) {
                mobileTable += '<div class="table-footer mt-3">' + navPriceTable.tableData.FooterText + '</div>';
            }
            mobileTable += '</div></div></div>'
            $(navPriceTable.wrapperDiv).append(mobileTable);
        },
        drawMobileCardArray: (dataSet, headerColumns, headerArray) => {
            var mobileCard = ''
            var headerArraySize = headerArray.length-1;
            if (navPriceTable.tableType == "NAV") {
                monthArray = dataSet.NavMonthItems
                quarterArray = dataSet.NavQuarterItems
            } else {
                monthArray = dataSet.PriceMonthItems
                quarterArray = dataSet.PriceQuarterItems
            }
            $.each(monthArray, function (index) {
                quarterObj = quarterArray[index]
                columnName = headerArray[headerArraySize]
                mobileCard += '<div class="fund-explorer-table__card">';
                mobileCard += commonFundUtils.drawMobileHeader(this, headerColumns, headerArray)
                mobileCard += '<div class="row">'
                mobileCard += '<div class=" fund-explorer-table__card-body col-12"><div class="fund-explorer-table__card-column ">Month-End - ' + navPriceTable.tableData.MonthEndDate + '</div></div>'
                mobileCard += commonFundUtils.drawMobileItems(this, headerColumns, navPriceTable.tableData.MonthEndColumns.length, headerArray, navPriceTable.tableHeaderTitles)
                mobileCard += '<div class=" fund-explorer-table__card-body col-12"><div class="fund-explorer-table__card-column ">Quarter-End - ' + navPriceTable.tableData.QuarterEndDate + '</div></div>'
                mobileCard += commonFundUtils.drawMobileItems(quarterObj, navPriceTable.tableData.MonthEndColumns.length, navPriceTable.tableData.MonthEndColumns.length + 3, headerArray, navPriceTable.tableHeaderTitles)
                mobileCard += '<div class=" fund-explorer-table__card-body col-12"><div class="fund-explorer-table__card-column "></div></div>'
                mobileCard += commonFundUtils.drawMobileItems(quarterObj, navPriceTable.tableData.MonthEndColumns.length + 3, headerArray.length, headerArray, navPriceTable.tableHeaderTitles)
                mobileCard += '</div>'
                mobileCard += '</div>'
            })
            //console.log("mobile card for the navprice table",mobileCard)
            return mobileCard;
        },
        drawExcelTable: (wrapperDiv) => {
            var excelTable = '';
            navPriceTable.isExcelDownloading = true
            $('#excelDrawArea table').remove();
            excelTable += '<table class="d-none excel-table" border="1">';
            excelTable += navPriceTable.drawHeader(navPriceTable.tableData)
            excelTable += navPriceTable.drawBlock(navPriceTable.tableHeaderArray, navPriceTable.tableClassesArray , navPriceTable.isExcelDownloading)
            excelTable += '</table>';
            $('#excelDrawArea').append(excelTable);
            commonFundUtils.downloadExcelReport(wrapperDiv);
        }
    }

    //function is only initiated if the block ID is a number
    if (!isNaN(navPriceTable.blockId)) {
        navPriceTable.init()
    }
})